<div class="container-fluid">
  <div class="d-flex">
    <img
      class="w-25 h-25 d-none d-md-block"
      src="../assets/images/Edna_Mode_promotional_image.png"
      alt="Edna promotional image">
    <div class="jumbotron row justify-content-start">
      <h1
        class="display-4"
        routerLink="/">incredible online store</h1>
      <div class="container">
        <article>
          <p>This application contain a <span class="badge bg-danger">GoodsModule</span> with components:</p>
          <ul>
            <li><span class="badge bg-primary">GoodCenter</span>: could have a child components</li>
            <li><span class="badge bg-primary">GoodList</span>: contain a list of goods and each of list item should redirect to GoodDetails component</li>
            <li><span class="badge bg-primary">GoodDetails</span>: contain data about selected good</li>
            <li><span class="badge bg-primary">GoodTemplateDrivenForm</span>: should create, update or delete existing component</li>
          </ul>
          <p>Service:</p>
          <ul>
            <li><span class="badge bg-warning">FirebaseService</span>: manipulate with data in Firebase Cloud Firestore NoSQL database</li>
          </ul>
        </article>
      </div>
    </div>
  </div>
  <hr class="my-4">
  <router-outlet></router-outlet>
</div>
